package com.iregained.site.components.sections.clinicians.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.px

val ImpactBarContainerStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .backgroundColor(colorMode.toSitePalette().custom.lightGray)
}

val ImpactBarGridStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .maxWidth(1200.px)
        .gap(32.px)
}

val ImpactStatItemStyle = CssStyle.base {
    Modifier.fillMaxWidth()
}

val ImpactStatIconStyle = CssStyle.base {
    Modifier
        .size(48.px)
        .margin(right = 16.px)
}

val ImpactStatValueStyle = CssStyle.base {
    Modifier
        .fontSize(20.px)
        .fontWeight(FontWeight.Bold)
        // Using the Brand Teal for the big numbers to make them pop
        .color(colorMode.toSitePalette().brand.primary)
        .margin(bottom = 4.px)
}

val ImpactStatLabelStyle = CssStyle.base {
    Modifier
        .fontSize(14.px)
        // FIXED: Swapped to darkText so it is readable against the lightGray background
        .color(colorMode.toSitePalette().custom.darkText)
        .lineHeight(1.4)
}